import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { mountPlayer } from "./player/controller";
import { playerTemplate } from "./player/template";
import "./player/player.css";

export type PlayerHandle = {
  command: (action: string, value: unknown) => void;
};
const api = {
  endpoint:
    process.env.REACT_APP_HLTV_DEMO_API || process.env.REACT_APP_PARTNER_URL,
  apiKey: process.env.REACT_APP_PLAYLIST_API_KEY || "",
  whereami: process.env.REACT_APP_WHEREAMI_URL,
};
export const HLTVPlayer = forwardRef<
  PlayerHandle,
  {
    search: string;
    onStatus?: (value: string) => void;
    onHeight?: (value: number) => void;
  }
>(({ search, onStatus, onHeight }, ref) => {
  const root = useRef<HTMLDivElement>(null);
  const controller = useRef<ReturnType<typeof mountPlayer>>();
  const callbacks = useRef({ onStatus, onHeight });
  callbacks.current = { onStatus, onHeight };
  useImperativeHandle(
    ref,
    () => ({
      command: (action, value) => controller.current?.command(action, value),
    }),
    [],
  );
  useEffect(() => {
    const node = root.current!;
    // This is a bundled, static template. Campaign data is inserted as text/DOM
    // by the controller, never interpolated into HTML.
    node.innerHTML = playerTemplate;
    controller.current = mountPlayer(node, {
      search,
      api,
      onStatus: (value: string) => callbacks.current.onStatus?.(value),
      onHeight: (value: number) => callbacks.current.onHeight?.(value),
    });
    return () => {
      controller.current?.destroy();
      controller.current = undefined;
    };
  }, [search]);
  return (
    <>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap"
      />
      <div className="hltv-player" ref={root} />
    </>
  );
});
HLTVPlayer.displayName = "HLTVPlayer";
